import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { of } from 'rxjs/observable/of';

@Component({
    selector: 'app-auto-complete',
    templateUrl: './auto-complete.component.html',
    styleUrls: ['./auto-complete.component.scss']
})
export class AutoCompleteComponent implements OnInit {

    @ViewChild('listSearchInput') listSearchInput: ElementRef;
    @Output() onSelect = new EventEmitter<string>();
    @Input() list: any[]
    @Input() placeholder: string = "Search"

    // cars: any = [];
    showSearches: boolean = false;
    isSearching: boolean = false;
    searchedList: any = [];

    constructor() {
        // this.cars = ['Audi', 'BMW', 'Bugatti', 'Ferrari', 'Ford', 'Lamborghini', 'Mercedes Benz', 'Porsche', 'Rolls-Royce', 'Volkswagen'];

    }

    ngOnInit() {
        this.searchedList = this.list;
        this.listSearch();

        window.addEventListener('click', (e: any) => {
            if (!document.getElementById('input').contains(e.target)) {
                this.showSearches = false
            }
        });
    }

    getLists(name): Observable<any> {
        return of(this.filterLists(name))
    }

    filterLists(name) {
        return this.list.filter((val) => val.toLowerCase().includes(name.toLowerCase()) == true)
    }

    listSearch() {
        const search$ = fromEvent(this.listSearchInput.nativeElement, 'keyup')
            .map((event: any) => event.target.value)
            .debounceTime(500)
            .distinctUntilChanged()
            .do((res: any) => {
                this.onSelect.emit(res);
                this.isSearching = true
            })
            .switchMap((term) => term ? this.getLists(term) : of<any>(this.list))
            .do(() => {
                this.isSearching = false,
                    this.showSearches = true;
            })

        search$.subscribe(data => {
            this.isSearching = false
            this.searchedList = data;
        })
    }

    setSelected(name) {
        this.searchedList = this.filterLists(name);
        this.onSelect.emit(name);
        this.listSearchInput.nativeElement.value = name;
        this.showSearches = false;
    }

    trackById(index, item): void {
        return item._id;
    }

    closeDropDown(): void {
        this.showSearches = false;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/auto-complete/auto-complete.component.ts